import clsx from 'clsx';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { useUser } from '@clerk/nextjs';

export const ProfileButton = () => {
  const { user } = useUser();

  return (
    <Link
      href="/kunde"
      className={clsx(
        'flex items-center relative',
        'md:gap-2 py-2 mr-2 md:pl-3 md:mr-0',
        'focus:outline-none ring-offset-focus focus-visible:ring-4'
      )}
      title="handlekurv"
    >
      <UserCircleIcon className="h-5 w-5" />
      {user && (
        <span className="block w-2 h-2 bg-secondary-50 aspect-square rounded-full absolute top-1 -right-1"></span>
      )}
    </Link>
  );
};
